import { Box } from '@mantine/core';
import { useGetColor } from 'hooks';
import type { IconPropsType } from './types';

export const ShareIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);
  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="-2 -3 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 8.00452L9 8.00452M11.5 4.50452L9 7.99994L11.5 11.5045M15 3.00321C15 4.10649 14.104 5.00191 13 5.00191C11.896 5.00191 11 4.10649 11 3.00321C11 1.89993 11.896 1.00452 13 1.00452C14.104 1.00452 15 1.89993 15 3.00321ZM15 12.9967C15 14.1 14.104 14.9954 13 14.9954C11.896 14.9954 11 14.1 11 12.9967C11 11.8934 11.896 10.998 13 10.998C14.104 10.998 15 11.8934 15 12.9967ZM5 7.99995C5 9.10323 4.104 9.99864 3 9.99864C1.896 9.99864 1 9.10323 1 7.99995C1 6.89667 1.896 6.00125 3 6.00125C4.104 6.00125 5 6.89667 5 7.99995Z"
        stroke={iconColor}
        strokeWidth={1.5}
        strokeLinecap="square"
      />
    </Box>
  );
};
